import { useTranslations } from 'next-intl'

import { Icon, TextButton } from '@/shared/ui'

import { useFilter } from '../../model/filter'

export const ResetButton = () => {
  const t = useTranslations('filter')

  const { resetFilter } = useFilter()

  const handleClick = () => {
    resetFilter()
  }

  return (
    <TextButton size="large" onClick={handleClick}>
      <Icon name="reset" />
      {t('reset')}
    </TextButton>
  )
}
